<template>
  <section class="admin-left-sidebar">
    <div class="menu-toggle-button">
      <button id="leftMenuSlide"></button>
    </div>
    <div class="left-sidebar-scrollbar">
      <ul class="left-sidebar-bg">
        <li>
          <router-link
            :class="{ active: $route.path === '/authority/dashboard' }"
            to="/authority/dashboard"
            id="dashboardMenuLink"
            ><i
              class="dashboard-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Dashboard"
            ></i>
            <span>{{ constants.DASHBOARD_MENU }}</span></router-link
          >
        </li>
        <li>
          <router-link
            :class="{ active: $route.path === '/authority/Banners' }"
            to="/authority/Banners"
            id="bannerImagesMenuLink"
            ><i
              class="banner-images-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Banner Images"
            ></i>
            <span>{{ constants.BANNER_IMAGES_MENU }}</span></router-link
          >
        </li>
        <li>
          <router-link
            :class="{ active: $route.path === '/authority/services' }"
            to="/authority/services"
            id="servicesMenuLink"
            ><i
              class="services-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Services"
            ></i>
            <span>{{ constants.SERVICES_MENU }}</span></router-link
          >
        </li>
        <li>
          <router-link
            :class="{ active: $route.path === '/authority/articles' }"
            to="/authority/articles"
            id="articlesMenuLink"
            ><i
              class="articles-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Articles"
            ></i>
            <span>{{ constants.ARTICLES_MENU }}</span></router-link
          >
        </li>
        <li>
          <router-link
            :class="{ active: $route.path === '/authority/industry' }"
            to="/authority/industry"
            id="industryMenuLink"
            ><i
              class="industry-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Industry"
            ></i>
            <span>{{ constants.INDUSTRY_MENU }}</span></router-link
          >
        </li>
        <li>
          <router-link
            :class="{ active: $route.path === '/authority/clients' }"
            to="/authority/clients"
            id="clientsMenuLink"
            ><i
              class="clients-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Clients"
            ></i>
            <span>{{ constants.CLIENTS_MENU }}</span></router-link
          >
        </li>
        <li class="have-item" id="jobsMenuDropDown">
          <a
            id="jobsMenuLink"
            href="javascript:void(0)"
            :class="{ active: isJobsMenuActive }"
            class="adminSubMenu arrow"
            ><i
              class="jobs-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Jobs"
            ></i>
            <span>{{ constants.JOBS_MENU }}</span></a
          >
          <ul>
            <li>
              <router-link
                :class="{ active: $route.path === '/authority/manage-job' }"
                to="/authority/manage-job"
                id="manageJobsMenuLink"
                >{{ constants.MANAGE_JOBS_MENU }}</router-link
              >
            </li>
            <li>
              <router-link
                :class="{ active: $route.path === '/authority/job-category' }"
                to="/authority/job-category"
                id="jobCategoryMenuLink"
                >{{ constants.JOB_CATEGORY_MENU }}</router-link
              >
            </li>
          </ul>
        </li>
        <li class="have-item" id="teamMenuDropDown">
          <a
            id="teamMenuLink"
            href="javascript:void(0)"
            :class="{ active: isTeamsMenuActive }"
            class="adminSubMenu arrow"
            ><i
              class="team-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Team"
            ></i>
            <span>{{ constants.TEAM_MENU }}</span></a
          >
          <ul>
            <li>
              <router-link
                :class="{ active: $route.path === '/authority/manage-team' }"
                to="/authority/manage-team"
                id="manageTeamMenuLink"
                >{{ constants.MANAGE_TEAM_MENU }}</router-link
              >
            </li>
            <li>
              <router-link
                :class="{ active: $route.path === '/authority/join-team' }"
                to="/authority/join-team"
                id="joinOurTeamMenuLink"
                >{{ constants.JOIN_OUR_TEAM_MENU }}</router-link
              >
            </li>
          </ul>
        </li>
        <li class="have-item" id="blogMenuDropDown">
          <a
            id="blogMenuLink"
            href="javascript:void(0)"
            :class="{ active: isBlogsMenuActive }"
            class="adminSubMenu arrow"
            ><i
              class="blog-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Blog"
            ></i>
            <span>{{ constants.BLOG_MENU }}</span></a
          >
          <ul>
            <li>
              <router-link
                :class="{ active: $route.path === '/authority/manage-blog' }"
                to="/authority/manage-blog"
                id="manageBlogMenuLink"
                >{{ constants.MANAGE_BLOG_MENU }}</router-link
              >
            </li>
            <li>
              <router-link
                :class="{ active: $route.path === '/authority/blog-category' }"
                to="/authority/blog-category"
                id="blogCategoryMenuLink"
                >{{ constants.BLOG_CATEGORY_MENU }}</router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link
            :class="{ active: $route.path === '/authority/contactUs' }"
            to="/authority/contactUs"
            id="contactMenuLink"
            ><i
              class="contact-us-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Contact Us"
            ></i>
            <span>{{ constants.CONTACT_US_MENU }}</span></router-link
          >
        </li>
        <li>
          <router-link
            id="emailTemplateMenuLink"
            to="/authority/email-template"
            :class="{ active: $route.path === '/authority/email-template' }"
          >
            <i
              class="email-template-menu"
              data-toggle="tooltip"
              data-placement="right"
              title="Email Template"
            ></i>
            <span>
              {{ constants.EMAIL_TEMPLATE_MENU }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link id="emailLogsMenuLink" :class="{ active: $route.path === '/authority/email-logs' }" to="/authority/email-logs" >
										<i class="email-logs-menu" data-toggle="tooltip" data-placement="right" title="Email Logs"></i>
										<span>
                      {{ constants.EMAIL_LOGS_MENU }}
										</span>
          </router-link>
        </li>
        <li>
          <router-link id="uploadDocumentMenuLink" :class="{ active: $route.path === '/authority/upload-documents' }" to="/authority/upload-documents" >
            <i class="upload-documents-menu" data-toggle="tooltip" data-placement="right" title="Upload Documents"></i>
            <span>
              {{ constants.UPLOAD_DOCUMENTS_MENU }}
            </span>
          </router-link>
        </li>
        <li>
          <router-link to="/logout" @click="logout()" id="logoutMenuLink"
            ><i
              class="logout-us-menu"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Logout"
            ></i>
            <span>{{ constants.LOGOUT_MENU }}</span></router-link
          >
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import constants from "@/utils/en-US-Admin.json";
import customJSFunction from "@/assets/js/custom.js";
import { Tooltip } from "bootstrap";

export default {
  name: "adminNavigation",
  data() {
    return {
      constants,
      tooltips: [],
    };
  },
  computed: {
    isJobsMenuActive() {
      return (
        this.$route.path === "/authority/manage-job" ||
        this.$route.path === "/authority/job-category"
      );
    },
    isTeamsMenuActive() {
      return (
        this.$route.path === "/authority/manage-team" ||
        this.$route.path === "/authority/join-team"
      );
    },
    isBlogsMenuActive() {
      return (
        this.$route.path === "/authority/manage-blog" ||
        this.$route.path === "/authority/blog-category"
      );
    },
  },
  mounted() {
    customJSFunction();
    this.initializeTooltips();
    document.addEventListener("click", (event) => {
      if (event.target.tagName === "I") {
        const tooltip = document.querySelector(".tooltip.bs-tooltip-auto");
        if (tooltip) {
          tooltip.remove();
        }
      }
    });
  },
  beforeUnmount() {
    this.destroyTooltips();
  },
  methods: {
    initializeTooltips() {
      if (Tooltip) {
        const tooltipElements = document.querySelectorAll(
          '[data-bs-toggle="tooltip"]'
        );
        tooltipElements.forEach((element) => {
          const tooltip = new Tooltip(element);
          this.tooltips.push(tooltip);
        });
      } else {
        console.error("Tooltip function is not defined");
      }
    },
    destroy() {
      this._element.remove();
    },
    destroyTooltips() {
      this.tooltips.forEach((tooltip) => {
        if (tooltip && tooltip._element) {
          tooltip.dispose();
        }
      });
      this.tooltips = [];
    },

    logout() {
      localStorage.clear();
      this.$router.push({ name: "Login" });
    },
  },
  watch: {
    $route() {
      this.destroyTooltips();
      this.$nextTick(() => {
        this.initializeTooltips();
      });
    },
  },
};
</script>
